import professionalTrigger from './professional-trigger';

export default professionalTrigger;
